import axios from 'axios'
export default {
	namespaced: true,
	state: {
		endpoint: '/document/member/type',
		name: 'DocumentMemberType',
		title: {
			single: 'DocumentMemberType',
			plural: 'DocumentMemberTypes'
		},
		icon: 'mdi-format-list-bulleted-type',
		items: [],
	},
	actions: {
		load (context, data) {
			return axios.get(context.getters.endpoint).then(response => {
				context.commit('items', response.data)
			}, error => {
				console.log('error', error)
			})
		},
	},
}
